import React from "react";
import styled from "styled-components";

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => {
  return (
    <Wrapper>
      <IconWrap>{icon}</IconWrap>
      <Title>{title}</Title>
      <Description>{description}</Description>
      {action && <ActionWrap>{action}</ActionWrap>}
    </Wrapper>
  );
};

export default EmptyState;

const Wrapper = styled.div`
  padding: 48px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

const IconWrap = styled.div`
  color: #d1d5db;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.p`
  margin: 0 0 8px 0;
  font-family: "Urbanist", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #171717;
`;

const Description = styled.span`
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.65);
  line-height: 1.4;
  max-width: 360px;
`;

const ActionWrap = styled.div`
  margin-top: 20px;
`;
